import Moment from 'moment-timezone';
import XLSX from 'xlsx';
import { setColumnSize } from '@/utils/sheets';
import { i18n } from '@/plugins/i18n';

/**
 * Create an excel sheet for a list of users
 * @param  {Array} users    List of users
 */
export function exportUsersToExcel(users) {
  const dateFormat = i18n.t('dateFormat');
  const userColumns = [
    i18n.t('message.ID'),
    i18n.t('message.USERNAME'),
    i18n.t('message.FIRST_NAME'),
    i18n.t('message.LAST_NAME'),
    i18n.t('message.EMAIL'),
    i18n.t('message.CREATED'),
    i18n.t('message.TEAM'),
    i18n.t('message.LAST_CONNECTION'),
    i18n.t('message.FIRST_CONNECTION'),
  ];

  const userRows = [userColumns];
  const now = Moment();
  users.forEach((user) => {
    userRows.push([
      user.id,
      user.username,
      user.firstName,
      user.lastName,
      user.email,
      user.created,
      user.refTeamName,
      user.lastConnection,
      user.firstConnection,
    ]);
  });
  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: i18n.t('message.USERS'),
    Subject: i18n.t('message.USERS'),
    CreateDate: Moment().format(dateFormat),
  };

  const usersSheet = XLSX.utils.aoa_to_sheet(userRows);
  setColumnSize(usersSheet, 15);
  XLSX.utils.book_append_sheet(wb, usersSheet, i18n.t('message.USERS'));
  XLSX.writeFile(wb, `${i18n.t('message.USERS')}_Shizen_${now.format(i18n.t('lFullDateFormat'))}.xlsx`);
}

export default {
  exportUsersToExcel,
};
